// ── Step 6 Fact Questions — Pure DOM writes, no state or API ──────────────

function createFactQuestionElement(question) {
  const item = document.createElement('li');
  item.textContent = String(question ?? '');
  return item;
}

/** Renders diagnostic fact questions without treating the question text as HTML. */
export function renderRevisionFactQuestionsInto(root, questions = []) {
  if (!root) return;
  const items = Array.isArray(questions) ? questions : [];
  root.replaceChildren(...items.map(createFactQuestionElement));
}
